import React, { useContext, useEffect, useState } from "react";
import Card from "./Card";
import firebase from "../../firebase";
import { DashboardContext } from "../../contexts/DashboardContext";
import Button from "components/forms/Button";
import { ModalCodeSearch } from "components/modals/ModalCodeSearch";
import { Code } from "components/layout/Code";
import Badge from "components/ui/Badge";
import ModalPhotoBoothSession from "components/modals/ModalPhotoBoothSession";
import { PhotoBoothSession } from "@mijnfotohoek-types";
import moment from "moment";
import {
  FaArchive,
  FaCamera,
  FaChevronDown,
  FaCog,
  FaPencilAlt,
  FaSearch,
} from "react-icons/fa";
import ModalPhotoBoothSessionRename from "components/modals/ModalPhotoBoothSessionRename";
import ModalPhotoBoothSessionArchive from "components/modals/ModalPhotoBoothSessionArchive";

export default function CardDashboardHistory() {
  // @ts-ignore
  const { user } = useContext(DashboardContext);
  const [data, setData] = useState<PhotoBoothSession[]>([]);
  useEffect(() => {
    if (user != null) {
      const unsubscribe = firebase
        .firestore()
        .collection("photo_booth_sessions")
        .where("user", "==", user)
        .orderBy("createdAt", "desc")
        .onSnapshot((snapshot) => {
          const docs = snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          });

          setData(docs as PhotoBoothSession[]);
        });
      return () => unsubscribe();
    }
  }, [user]);

  const [modalCodeSearch, setModalCodeSearch] = useState(false);
  const [modalPhotoBoothSession, setModalPhotoBoothSession] = useState(false);
  const [selectedPhotoBoothSession, setSelectedPhotoBoothSession] =
    useState<PhotoBoothSession | null>(null);

  const openPhotoBoothSession = (photoBoothSession: PhotoBoothSession) => {
    setSelectedPhotoBoothSession(photoBoothSession);
    setModalPhotoBoothSession(true);
  };

  const [showArchived, setShowArchived] = useState(false);

  return (
    <Card
      className="md:col-start-1 md:col-end-4"
      title={`Fotohoeken beheren`}
      cardAction={
        <Button onClick={() => setModalCodeSearch(true)} isButtonIcon={true}>
          <FaSearch />
        </Button>
      }
    >
      {modalCodeSearch && (
        <ModalCodeSearch close={() => setModalCodeSearch(false)} />
      )}

      {modalPhotoBoothSession && (
        <ModalPhotoBoothSession
          close={() => setModalPhotoBoothSession(false)}
          photoBoothSession={selectedPhotoBoothSession}
        />
      )}

      {data.length === 0 && <p>Je hebt nog geen fotohoeken aangemaakt</p>}

      <div className="flex flex-col gap-4">
        {data
          .filter((d) => !d.archived)
          .map((d) => (
            <PhotoBoothSessionListItem
              photoBoothSession={d}
              key={d.id}
              openAction={openPhotoBoothSession}
            />
          ))}
      </div>
      {data.filter((d) => d.archived).length > 0 && (
        <>
          <div
            className="border-solid border-b border-gray-200 text-gray-400 text-sm flex justify-between cursor-pointer"
            onClick={() => setShowArchived(!showArchived)}
          >
            <p>
              Gearchiveerde fotohoeken ({data.filter((d) => d.archived).length})
            </p>
            <FaChevronDown
              className={
                showArchived
                  ? "rotate-180 transition-transform"
                  : "transition-transform"
              }
            />
          </div>
          {showArchived &&
            data
              .filter((d) => d.archived)
              .map((d) => (
                <PhotoBoothSessionListItem
                  photoBoothSession={d}
                  key={d.id}
                  openAction={openPhotoBoothSession}
                />
              ))}
        </>
      )}
    </Card>
  );
}

const Avatar = ({ className }: { className?: string }) => {
  return (
    <div className={`w-12 h-12   bg-gray-300 rounded-full ${className || ""}`}>
      <FaCamera className="w-6 h-6 m-3 text-gray-400" />
    </div>
  );
};

const Avatars = () => {
  return (
    <div className="flex gap-2">
      <Avatar className="!bg-gray-200 relative" />
      {/* <Avatar className="-ml-8" /> */}
    </div>
  );
};

const PhotoBoothSessionListItem = ({
  photoBoothSession,
  openAction,
}: {
  photoBoothSession: PhotoBoothSession;
  openAction?: (photoBoothSession: PhotoBoothSession) => void;
}) => {
  const [modalRename, setModalRename] = useState(false);
  const [modalArchive, setModalArchive] = useState(false);
  return (
    <div className="w-full border-solid px-8 py-6 border-gray-200  items-center border-2 rounded-xl flex justify-between">
      {modalRename && (
        <ModalPhotoBoothSessionRename
          session={photoBoothSession}
          close={() => setModalRename(false)}
        />
      )}
      {modalArchive && (
        <ModalPhotoBoothSessionArchive
          session={photoBoothSession}
          close={() => setModalArchive(false)}
        />
      )}
      <div className="flex gap-4 items-center">
        {/* <Avatars /> */}
        <div>
          <h1 className="font-bold text-xl">{photoBoothSession.title}</h1>
          <div className="flex gap-1">
            <Badge>
              Aangemaakt op{" "}
              <span className="font-semibold">
                {moment(photoBoothSession.createdAt.toDate()).format(
                  "ddd DD MMM YYYY",
                )}
              </span>
            </Badge>
            <Badge variant="outline" className="font-semibold">
              {photoBoothSession.qrCodesCount} QR-codes
            </Badge>
          </div>
        </div>
      </div>
      <div className="flex gap-2">
        <Button
          isButtonIcon={true}
          onClick={() => setModalArchive(true)}
          className="text-gray-600 bg-gray-200"
        >
          <FaArchive />
        </Button>
        <Button
          isButtonIcon={true}
          onClick={() => setModalRename(true)}
          className="mr-2"
        >
          <FaPencilAlt />
        </Button>
        <span className="mr-2 border-r-2 border-solid border-gray-200"></span>
        <Button
          isButtonIcon={true}
          onClick={() => openAction(photoBoothSession)}
        >
          <FaCog />
        </Button>
      </div>
    </div>
  );
};
